export default __webpack_public_path__ + "static/media/welcome-main-sec-bg.6bab94fd.jpg";